export class AzureOnboardedTenantsResponse {
    'tenantIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantIds",
            "baseName": "tenantIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AzureOnboardedTenantsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
